import type { IconData } from '@stacksjs/iconify-core'

export const angleDown: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 15.121a1 1 0 0 1-.707-.293L7.05 10.586a1 1 0 0 1 1.414-1.414L12 12.707l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.242a1 1 0 0 1-.707.293\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default angleDown
